module.exports = __webpack_public_path__ + "media/img/illustrations/icons/action-cancel-ff879bdc2f924763c8a197e83c15c132.svg";